import { render, staticRenderFns } from "./CouponInfoCard.vue?vue&type=template&id=27dc5310&scoped=true&"
import script from "./CouponInfoCard.vue?vue&type=script&lang=js&"
export * from "./CouponInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc5310",
  null
  
)

export default component.exports